import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account.component';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppBreadcrumbModule } from '@coreui/angular';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { FooterModule } from '../../core-components/footer/footer.module';
import { HeaderModule } from '../../core-components/header/header.module';
import { LanguageModule } from '../../core-components/language/language.module';
import { ToolbarModule } from '../../core-components/toolbar copy/toolbar.module';
import { InputErrorPipeModule } from '../../pipes/input-error-pipe.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { AccountRoutingModule } from './account-routing.module';

@NgModule({
  declarations: [AccountComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    AppBreadcrumbModule,
    HttpClientModule,
    TranslateModule,
    LanguageModule,
    FlexLayoutModule,
    HeaderModule,
    FooterModule,
    InputErrorPipeModule,
    BreadcrumbModule,
    SharedComponentsModule,
    ToolbarModule,
    AccountRoutingModule
  ]
})
export class AccountModule { }
